import { divIcon, type DivIcon } from 'leaflet';
import { SUBMISSION_STATUS_PIN_CLASS } from '../constants/instituteSubmission.constants';
import type { SubmissionStatus } from '../types/instituteSubmission.types';

const PIN_HEIGHT = 48;
const PIN_TIP_ORIGIN_CLASS = 'origin-[40%_98%]';
const MOBILE_PIN_SCALE_CLASS = 'max-lg:scale-75';
const PIN_SHAPE_PATH =
  'M13.5 0C6.04 0 0 6.04 0 13.5c0 10.13 13.5 29.5 13.5 29.5S27 23.63 27 13.5C27 6.04 20.96 0 13.5 0z';

const pinIconCache = new Map<SubmissionStatus, DivIcon>();

export function getSubmissionPinIcon(status: SubmissionStatus): DivIcon {
  const cached = pinIconCache.get(status);
  if (cached) return cached;

  const width = (PIN_HEIGHT * 36) / 45;
  const icon = divIcon({
    className: '',
    iconSize: [width, PIN_HEIGHT],
    iconAnchor: [(14.5 / 36) * width, (44 / 45) * PIN_HEIGHT],
    tooltipAnchor: [0, -PIN_HEIGHT * 0.85],
    html: `<span class="relative block size-full ${PIN_TIP_ORIGIN_CLASS} ${MOBILE_PIN_SCALE_CLASS}"><svg viewBox="0 0 36 45" width="${width}" height="${PIN_HEIGHT}" class="overflow-visible ${SUBMISSION_STATUS_PIN_CLASS[status]} drop-shadow-[0_1px_2px_rgb(0_0_0/0.35)]">
      <g transform="translate(1 1)">
        <path d="${PIN_SHAPE_PATH}" fill="currentColor" stroke="rgb(0 0 0 / 0.25)" stroke-width="1" />
        <circle cx="13.5" cy="13.5" r="4.8" fill="rgb(0 0 0 / 0.35)" />
      </g>
    </svg></span>`,
  });

  pinIconCache.set(status, icon);
  return icon;
}
